import { render, staticRenderFns } from "./AddHeadingPopup.vue?vue&type=template&id=570f8f1a&"
import script from "./AddHeadingPopup.vue?vue&type=script&lang=js&"
export * from "./AddHeadingPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports